import { useAppSelector } from 'store/store-hooks';
import { ModalEnum } from 'components/app/_mediator/app.slice';
import { getFileName, usePickerContext } from './picker.provider';

import { Button } from 'components/UI/button/button';
import { Modal } from 'components/UI/modal/modal';
import styles from './_picker.module.scss';

export const PickerReplace = () => {
  const modal = useAppSelector((state) => state.app.modal);
  const { pickerReplaceData: data, closeModal, onUpload } = usePickerContext();
  return (
    <Modal className={styles.FilesReplaceModal} isOpen={modal === ModalEnum.replace} onRequestClose={closeModal}>
      {data && (
        <>
          <h3>These files have already been uploaded/processed, do you want to replace them?</h3>
          <ul>
            {data.existingFiles
              .map((file) => getFileName(file))
              .map((fileName, i) => (
                <li key={i}>{`${i + 1}. ${fileName}`}</li>
              ))}
          </ul>
          <footer>
            <Button onClick={() => onUpload(data.newFiles)} outlined>
              No
            </Button>
            <Button onClick={() => onUpload([...data.newFiles, ...data.existingFiles])}>Yes</Button>
          </footer>
        </>
      )}
    </Modal>
  );
};
